<template>
  <footer>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-7 email" id="signup">
          <Email/>
        </div>
        <div class="col-md-12 bottom">
          <div class="row">
            <div class="left col-md-6">
              <div class="logo">
                <img src="../assets/skyline-logo-white.svg" alt="Skyline" class="logo" />
                <a href="https://alwaysaugust.co/" target="_blank" rel="noopener noreferrer">
                  <img src="../assets/powered-by-august.svg" alt="Powered by August" class="august" />
                  <img src="../assets/powered-by-august-hover.svg" alt="Powered by August" class="august hover" />
                </a>
              </div>
            </div>
            <div class="right col-md-6">
              <ul class="social">
                <li><a href="https://www.facebook.com/SkylineConf/" target="_blank" rel="noopener noreferrer"><img src="../assets/facebook.svg" alt="Facebook" /></a></li>
                <li><a href="https://twitter.com/SkylineConf" target="_blank" rel="noopener noreferrer"><img src="../assets/twitter.svg" alt="Twitter" /></a></li>
                <li><a href="https://www.instagram.com/Skyline_Conference/" target="_blank" rel="noopener noreferrer"><img src="../assets/instagram.svg" alt="Instagram" /></a></li>
              </ul>
              <p>For sponsorship and media inquiries, please contact Jeff Tchadjeu:</p>
              <p><a href="mailto:jeff@skylineconference.co">jeff@skylineconference.co</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Email from "./Email"

export default {
  name: 'Footer',
  data: function () {
    return {
      isHome: false,
    }
  },
  watch: {
    '$route': {
      handler: function (to) {
        // determine whether or not to show the email footer
        this.isHome = to.name == 'Home'
      },
      immediate: true
    }
  },
  components: {
    Email,
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables";

footer {
  background-color: $pink;
  background-image: url("data:image/svg+xml,%3Csvg width='181px' height='167px' viewBox='0 0 181 167' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group-7'%3E%3Cpolygon id='Fill-1' fill='%2395EF5B' points='0 86.1252 21.084 107.2082 21.084 86.1252'%3E%3C/polygon%3E%3Cpolygon id='Fill-2' fill='%2395EF5B' points='103.6521 90.4488 180.2301 167.0278 180.2301 90.4488'%3E%3C/polygon%3E%3Cpolygon id='Fill-3' fill='%23FFFFFF' points='62.2412 90.0442 104.7322 90.8952 62.2412 48.8632 21.0602 48.8632'%3E%3C/polygon%3E%3Cpolygon id='Fill-4' fill='%23010101' points='62.9922 128.3835 141.9412 128.3835 104.5932 91.0345'%3E%3C/polygon%3E%3Cpolygon id='Fill-5' fill='%2395EF5B' points='62.2413 0.0006 62.2413 48.8636 104.5923 91.0356 104.5923 42.3516'%3E%3C/polygon%3E%3Cpolygon id='Fill-6' fill='%23010101' points='61.938 0.0177 104.875 42.9547 157.794 42.9547 114.857 0.0177'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: top right -1px;
  padding-top: 85px;
  padding-bottom: 75px;
  color: white;

  @media all and (max-width: $mobileMax) {
    background-size: 100px auto;
  }

  div.bottom {
    border-top: 1px solid white;
    padding-top: 85px;

    @media all and (min-width: $mobileMax + 1) {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.home {
    padding-top: 85px;

    div.bottom {
      border-top: none;
      padding-top: 0;
    }
  }
}

div.bottom {
  div.left {
    @media all and (max-width: $mobileMax) {
      text-align: center;
    }
  }

  div.right {
    text-align: right;

    @media all and (max-width: $mobileMax) {
      text-align: center;
    }

    p {
      font-size: 14px;
      margin: 0;

      a[href^="mailto"] {
        font-weight: 700;
        font-style: italic;
        text-decoration: underline;
        color: white;
      }
    }
  }
}

ul.social {
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  margin: 0 0 14px;

  @media all and (max-width: $mobileMax) {
    justify-content: center;
    margin: 30px 0;
  }

  li {
    margin: 0 13.3px 0 0;

    &:last-child {
      margin-right: 0;
    }

    a {
      border-color: white;
      border-width: 2px;
    }
  }
}

div.logo {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  img.logo {
    width: 217px;
    height: auto;
  }

  a {
    display: block;
    position: relative;

    img.hover {
      opacity: 0;
      position: absolute;
      top: 7px;
      left: 0;
    }

    &:hover {
      img.hover {
        opacity: 1;
      }
      img:not(.hover) {
        opacity: 0;
      }
    }
  }
}
</style>
